import { render } from "./EditCollection.vue?vue&type=template&id=853836e0&scoped=true"
import script from "./EditCollection.vue?vue&type=script&lang=js"
export * from "./EditCollection.vue?vue&type=script&lang=js"

import "./EditCollection.vue?vue&type=style&index=0&id=853836e0&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-853836e0"]])

export default __exports__